module.exports = __webpack_public_path__ + "static/media/death-drive.5ca34e5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/afc/death-drive.mp3
// module id = HWId
// module chunks = 0